import { render, staticRenderFns } from "./LogsTableDialog.vue?vue&type=template&id=24305052"
import script from "./LogsTableDialog.vue?vue&type=script&lang=js"
export * from "./LogsTableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports